import { cn } from '@src/components/ui';


/** Label-above-field group matching the .pen Settings forms (12px subtle label).
 * Wraps an `<Input>`/`<Select>`/etc. primitive with an optional error line. The
 * old `TextInput`/`FIELD_INPUT` duplicates were removed (T9) — consumers use the
 * shared `Input`/`Select`/`SelectField` primitives instead. */
function Field({ label, hint, error, className, children }) {
  return (
    <label className={cn('flex flex-col gap-1.5', className)}>
      <span className="flex items-center gap-2">
        <span className="text-xs font-medium text-ink-subtle">{label}</span>

        {hint
          ? <span className="text-[11px] text-ink-tertiary">{hint}</span>
          : null}
      </span>

      {children}

      {error
        ? <span className="text-[11.5px] text-danger">{error}</span>
        : null}
    </label>
  );
}

Field.displayName = 'Field';

export { Field };
